module.exports = __webpack_public_path__ + "static/img/danakil.efcf0a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/danakil.jpg
// module id = tuKs
// module chunks = 1